export type AnalyticsEventName =
  | 'landing_view'
  | 'calculator_view'
  | 'calculator_start'
  | 'calculator_complete'
  | 'related_calculator_click'
  | 'search_used'
  | 'copy_result'
  | 'radar_view'
  | 'radar_filter_apply'
  | 'radar_filter_saved'
  | 'radar_demo_enabled'
  | 'radar_source_click'
  | 'radar_watch_toggle'
  | 'radar_hide'
  | 'radar_hidden_restore'
  | 'inbox_open'
  | 'inbox_filter_used'
  | 'inbox_item_removed'
  | 'decision_context_opened';

export type AnalyticsSource = 'direct' | 'search' | 'related' | 'home';
export type AnalyticsSurface = 'housing' | 'bids' | 'support' | 'commercial-areas' | 'inbox';

export type AnalyticsEvent = Readonly<{
  name: AnalyticsEventName;
  calculatorId?: string;
  source?: AnalyticsSource;
  queryMatched?: boolean;
  surface?: AnalyticsSurface;
}>;

export interface AnalyticsClient {
  track(event: AnalyticsEvent): void;
}

const noopClient: AnalyticsClient = {
  track: () => undefined,
};

const navigationSourceKey = 'business-calculator-kr:calculator-source';
let activeClient: AnalyticsClient = noopClient;

export function configureAnalytics(client: AnalyticsClient): void {
  activeClient = client;
}

export function trackAnalytics(event: AnalyticsEvent): void {
  activeClient.track(event);
}

export function rememberCalculatorSource(source: Exclude<AnalyticsSource, 'direct'>): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(navigationSourceKey, source);
  } catch {
    // Analytics must never interfere with calculator navigation.
  }
}

export function consumeCalculatorSource(): AnalyticsSource {
  if (typeof window === 'undefined') return 'direct';
  try {
    const source = window.sessionStorage.getItem(navigationSourceKey);
    window.sessionStorage.removeItem(navigationSourceKey);
    if (source === 'home' || source === 'search' || source === 'related') {
      return source;
    }
  } catch {
    // Fall back to direct when storage is unavailable.
  }
  return 'direct';
}
